import React, { useState, useEffect } from "react";
import { Link, useHistory} from "react-router-dom";
import isEmpty from 'validator/lib/isEmpty';
import isEmail from 'validator/lib/isEmail';
import equals from 'validator/lib/equals';
import {showErrorMsg , showSuccessMsg} from '../helpers/message';
import { showLoading, showLoadingBtn } from "../helpers/loading";
import { signup, checkisusername } from "../api/auth";
import { isAuthenticated } from "../helpers/auth";
//import { response } from "express";
const mongoose = require("mongoose");


const Register = () => {

    let history = useHistory();

    useEffect(() => {
        if(isAuthenticated() && isAuthenticated().role === 10) {
            history.push('/admin/dashboard/');
        } else if (isAuthenticated() && isAuthenticated().role === 0){
            history.push('/user/dashboard/');
        }
    },[history]);

    const [formData, setFormData] = useState({
        email:'',
        password:'',
        name:'',
        password2:'',
        _id:new mongoose.Types.ObjectId(),
        teamId:new mongoose.Types.ObjectId(),
        successMsg: false,
        errorMsg: false,
        loading: false
    })
    const {email, password, password2, successMsg, errorMsg, name, loading, _id, teamId } = formData;

    // EVENT HANDLER

    const handleChange = (evt) => {
        //console.log(evt);

        setFormData({
            ...formData,
            [evt.target.name]: evt.target.value,
            errorMsg: '',
            successMsg: '',   
        });
    } 

    const handleBlur = (evt) => {
        //console.log(evt.target.value.length);
        setFormData({
            ...formData,
            [evt.target.name]: evt.target.value,
            errorMsg: '',
            successMsg: '', 
            usernameSuccessMsg: '',
            usernameErrorMsg: '',    
        });
        if (!isEmail(email)){
            setFormData({
                ...formData, errorMsg: 'Invalid email',
            });    
        } 

    } 

    // const handleIsUsername = (evt) => {
    //     if (evt.target.value.length<3){
    //         setFormData({
    //             ...formData, usernameErrorMsg: 'Username be must least 3 character',
    //         });    
    //     } else if (isEmpty(username)){
    //         setFormData({
    //             ...formData, usernameErrorMsg: 'Please enter a username',
    //         });    
    //     } else if (evt.target.value.length>2){
    //         const {username, email, password} = formData;
    //         const data = {username, email, password};

    //         setFormData({...formData, [evt.target.name]: evt.target.value, loading: false});

    //         checkisusername(data)
    //             .then(response => {
    //             console.log('Axios signup success',response);
    //             setFormData({
    //                 username:username,
    //                 email:email,
    //                 password:password,
    //                 password2:password2,
    //                 loading: false,
    //                 usernameSuccessMsg: response.data.successMessage,
    //                 usernameErrorMsg:'',
    //              });
    //         })
    //         .catch(err => {
    //             console.log('axios signup error:' , err);
    //             setFormData({...formData, loading: false, usernameErrorMsg: err.response.data.errorMessage, usernameSuccessMsg:''});
    //         })
    //     }
    // }

    const handleSubmit = (evt) => {
        evt.preventDefault();

        // client-side validation
        
        if(isEmpty(email) || isEmpty(password) || isEmpty(name) || isEmpty(password2)) {
            
            setFormData({
                ...formData, errorMsg: 'All fields are required',
            });

        } else if (!isEmail(email)){
            setFormData({
                ...formData, errorMsg: 'Invalid email',
            });  
        } else if (!equals(password,password2)) {
            setFormData({
                ...formData, errorMsg: 'Password do not match',
            });
        } else {

            const {email, password, _id, name, teamId} = formData;
            const data = {email, password, _id, teamId, name};

            setFormData({...formData, loading: true});

            signup(data)
                .then(response => {
                    console.log('Axios signup success',response);
                    setFormData({
                        email: '',
                        password: '',
                        password2: '',
                        name:'',
                        loading: false,
                        successMsg: response.data.successMessage,
                     });
                })
                .catch(err => {
                    console.log('axios signup error:' , err);
                    setFormData({...formData, loading: false, errorMsg: err.response.data.errorMessage});
                })

        }

        //console.log(formData);
    };

    //VIEWS
    const showSignupForm = () => (

        <form onSubmit={handleSubmit} noValidate className="form-signin text-center">
      <img className="mb-4" src="data:image/jpeg;base64,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" alt="" width="72" height="72"/>
        <h1 className="h3 mb-3 font-weight-normal">muud.ly Register</h1>
        <label htmlFor="inputEmail" className="sr-only">Name</label>
        <input type="name" name="name" value={name} onChange={handleChange} placeholder="Your Name" className="form-control" required/>
        <label htmlFor="inputEmail" className="sr-only">Email address</label>
        <input type="email" name="email" value={email} onChange={handleChange} placeholder="example@mail.com" className="form-control" required/>
        <label htmlFor="inputPassword" className="sr-only">Password</label>
        <input type="password2" name="password" value={password} onChange={handleChange} className="form-control" placeholder="Your Password" required/>
        <label htmlFor="inputPassword" className="sr-only">Password</label>
        <input type="password2" name="password2" value={password2} onChange={handleChange} className="form-control" placeholder="Confirm Password" required/>
        {errorMsg && showErrorMsg(errorMsg)}
        {successMsg && showSuccessMsg(successMsg)}
        {
            loading ? (<div className='text-center'>{showLoadingBtn()}</div>) : (
            <button className="btn btn-lg btn-primary btn-block" type="submit">Register</button>
            )
        }
        <p className="mt-5 mb-3 text-muted">&copy; 2023</p>
      </form>

    );


    // RENDER
    return (
        
        <section className="centered">
            {showSignupForm()}
        </section>

    );

}

export default Register;